import { Reveal } from "@/components/motion/Reveal";
import { PROCESS } from "@/data/content";

export default function Process() {
  return (
    <section id="process" className="bg-concrete-900 text-white py-24 sm:py-32 grain relative">
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="mb-16 max-w-2xl">
          <span className="overline text-concrete-400">/ How it works</span>
          <h2 className="mt-4 font-display font-extrabold tracking-tighter text-5xl sm:text-6xl leading-[0.95]">
            No fuss.<br />Just solid work.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14">
          {PROCESS.map((p, i) => (
            <Reveal key={p.no} delay={(i % 2) * 0.1}>
              <div className="flex gap-6 border-t border-white/15 pt-6">
                <span className="font-mono text-concrete-400 text-lg shrink-0 pt-1">{p.no}</span>
                <div>
                  <h3 className="font-display font-bold text-3xl tracking-tight">{p.title}</h3>
                  <p className="mt-3 text-concrete-300 leading-relaxed max-w-sm">{p.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
